<template>
  <div class="dashboard-page">
    <v-container fluid class="dashboard-wrapper pa-4">
    <!-- Header -->
    <v-row class="mb-6 mt-1">
      <v-col cols="12" class="d-flex justify-space-between align-center py-0">
        <h1 class="text-h5 font-weight-bold" style="color: #1a237e;">Năm học {{ academicYear }}</h1>
      </v-col>
    </v-row>

    <!-- Main layout: Left (7/12) + Right (5/12) -->
    <v-row class="align-stretch">
      <!-- Left column -->
      <v-col cols="12" md="7" class="d-flex flex-column" style="gap: 24px;">
        <!-- Lớp + Học sinh + Giáo viên -->
        <DashboardSummary />

        <!-- Điểm danh -->
        <DashboardAttendanceToday />
      </v-col>

      <!-- Right column: Hoạt động hôm nay -->
      <v-col cols="12" md="5" class="d-flex flex-column mt-4 mt-md-0">
        <DashboardActivities class="flex-grow-1" />
      </v-col>
    </v-row>

    <!-- Tình trạng xe tuyến -->
    <v-row class="mt-4">
      <v-col cols="12">
        <DashboardBusStatus />
      </v-col>
    </v-row>

    <!-- Chuyên cần -->
    <v-row class="mt-4">
      <v-col cols="12">
        <DashboardAttendanceChart />
      </v-col>
    </v-row>

    <!-- Thông báo + Phản hồi -->
    <v-row class="mt-4 mb-4">
      <v-col cols="12" md="6">
        <DashboardAnnouncements />
      </v-col>
      <v-col cols="12" md="6">
        <DashboardFeedbacks />
      </v-col>
    </v-row>
  </v-container>
  </div>
</template>

<script>
import DashboardSummary from './components/Summary/DashboardSummary.vue'
import DashboardAttendanceToday from './components/AttendanceToday/DashboardAttendanceToday.vue'
import DashboardActivities from './components/Activities/DashboardActivities.vue'
import DashboardBusStatus from './components/BusStatus/DashboardBusStatus.vue'
import DashboardAttendanceChart from './components/AttendanceChart/DashboardAttendanceChart.vue'
import DashboardAnnouncements from './components/Announcements/DashboardAnnouncements.vue'
import DashboardFeedbacks from './components/Feedbacks/DashboardFeedbacks.vue'

export default {
  name: 'Dashboard',
  components: {
    DashboardSummary,
    DashboardAttendanceToday,
    DashboardActivities,
    DashboardBusStatus,

    DashboardAttendanceChart,
    DashboardAnnouncements,
    DashboardFeedbacks,
  },
  data: () => ({
  }),
  computed: {
    academicYear() {
      return localStorage.getItem('currentYear') || ''
    }
  }
}
</script>

<style scoped>
.dashboard-page {
  background-color: #e4f1fc;
  min-height: 100%;
  width: 100%;
}

.dashboard-wrapper {
  font-family: 'Roboto', sans-serif;
  max-width: 1440px;
  margin: 0 auto;
  overflow-x: hidden;
}
</style>
